import { reportMykissError } from '../../../../../../../helpers/errorHandling';
import { isOAuthError } from '../../../../../helpers/errors/isOAuthError';
import { ErrorCause } from '../../../../../types/errors/ErrorCause';

export const handleOAuthError = (error: unknown): string => {
  const { CognitoError, RegistrationError, TokenError, WindowError } = ErrorCause;
  const registrationErrorMessage = 'An error occurred while signing up. Please try again.';

  if (isOAuthError(error)) {
    if (error.cause === RegistrationError || error.cause === CognitoError) {
      return error.message;
    }
    if (error.cause === WindowError) {
      reportMykissError(error, undefined, 'warning');

      return '';
    }
    if (error.cause === TokenError) {
      reportMykissError(error);

      return registrationErrorMessage;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }

  return registrationErrorMessage;
};
